<template>
  <div class="title" :class="mode">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    mode: {
      type: String,
      required: false,
      default: null
    },    
  }
}
</script>
<style scoped>
.title {  
  font-weight: bold;
  font-size:16px;
}
</style>
